import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Typography,
  TextField,
  Button,
  Paper,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  
  Snackbar,
  Alert,
  Switch,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  TablePagination,
  InputAdornment,
  CircularProgress,
} from "@mui/material";
import ViewModuleIcon from "@mui/icons-material/ViewModule";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import { useNavigate } from "react-router-dom";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/Delete";
import SearchIcon from "@mui/icons-material/Search";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import UnfoldMoreIcon from "@mui/icons-material/UnfoldMore";
import axios from "axios";
import Menu from "@mui/material/Menu";

const options = [
  { label: "Add Credit", action: "addCredit" },
  { label: "Revert Credit", action: "revertCredit" },
  { label: "Whitelist", action: "whitelist" },
  { label: "Change Password", action: "changePassword" },
];

const ITEM_HEIGHT = 48;

const AddCreditDialog = ({ open, onClose, currentUser }) => {
  const [credit, setCredit] = useState("");
  const [remark, setRemark] = useState("");
  const [type, setType] = useState("whatsapp_balance");
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const handleSnackbarClose = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const handleAddCredit = async () => {
    const creditValue = Number(credit);

    if (isNaN(creditValue)) {
      setSnackbar({
        open: true,
        message: "Enter a valid credit amount.",
        severity: "error",
      });
      return;
    }

    try {
      const payload = {
        remark: remark?.trim() || null,
        transaction_user: "sagar124",
        type: type,
        username: currentUser?.username,
        whatsapp_balance: creditValue,
      };

      console.log("Sending payload:", payload);

      const response = await axios.post(
        "https://d3ioa5kdb9.execute-api.ap-south-1.amazonaws.com/Tis_whatsapp_be/add_credit",
        payload,
        {
          headers: { "Content-Type": "application/json" },
        }
      );

      if (response.status === 200) {
        setSnackbar({
          open: true,
          message: `Credit ${
            creditValue >= 0 ? "added" : "deducted"
          } successfully to ${
            type === "whatsapp_balance"
              ? "WhatsApp Balance"
              : "WhatsApp Button Balance"
          }!`,
          severity: "success",
        });
        setCredit("");
        setRemark("");
        setTimeout(onClose, 2000);
      } else {
        setSnackbar({
          open: true,
          message: "Unexpected server response.",
          severity: "warning",
        });
      }
    } catch (error) {
      console.error("Credit operation failed:", error);
      setSnackbar({
        open: true,
        message: `Failed to ${creditValue >= 0 ? "add" : "deduct"} credit.`,
        severity: "error",
      });
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        {currentUser?.username} - Credit Adjustment
        <IconButton
          onClick={onClose}
          sx={{ position: "absolute", right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Box mt={2}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <FormControl fullWidth margin="normal">
                <InputLabel>Transaction Type</InputLabel>
                <Select
                  value={type}
                  onChange={(e) => setType(e.target.value)}
                  label="Transaction Type"
                >
                  <MenuItem value="whatsapp_balance">WhatsApp Balance</MenuItem>
                  <MenuItem value="whatsapp_button_balance">
                    WhatsApp Button Balance
                  </MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Enter amount"
                type="number"
                value={credit}
                onChange={(e) => setCredit(e.target.value)}
                margin="normal"
                inputProps={{
                  inputMode: "numeric",
                  pattern: "-?[0-9]*",
                }}
                helperText="Enter positive to add credit, negative to deduct"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Remark"
                value={remark}
                onChange={(e) => setRemark(e.target.value)}
                margin="normal"
              />
            </Grid>
          </Grid>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={handleAddCredit} color="primary">
          {credit && Number(credit) >= 0 ? "Add Credit" : "Deduct Credit"}
        </Button>
      </DialogActions>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Dialog>
  );
};

const RevertCreditDialog = ({ open, onClose, currentUser }) => {
  const [credit, setCredit] = useState("");
  const [remark, setRemark] = useState("");
  const [type, setType] = useState("whatsapp_balance");
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const handleSnackbarClose = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const handleRevertCredit = async () => {
    const creditValue = Number(credit);

    if (isNaN(creditValue) || creditValue <= 0) {
      setSnackbar({
        open: true,
        message: "Enter a valid positive amount to revert.",
        severity: "error",
      });
      return;
    }

    try {
      const payload = {
        remark: remark?.trim() || null,
        transaction_user: "sagar124",
        type: type,
        username: currentUser?.username,
        whatsapp_balance: -Math.abs(creditValue),
      };

      console.log("Sending revert payload:", payload);

      const response = await axios.post(
        "https://d3ioa5kdb9.execute-api.ap-south-1.amazonaws.com/Tis_whatsapp_be/add_credit",
        payload,
        {
          headers: { "Content-Type": "application/json" },
        }
      );

      if (response.status === 200) {
        setSnackbar({
          open: true,
          message: `Credit reverted successfully from ${
            type === "whatsapp_balance"
              ? "WhatsApp Balance"
              : "WhatsApp Button Balance"
          }!`,
          severity: "success",
        });
        setCredit("");
        setRemark("");
        setTimeout(onClose, 2000);
      } else {
        setSnackbar({
          open: true,
          message: "Unexpected server response.",
          severity: "warning",
        });
      }
    } catch (error) {
      console.error("Revert credit failed:", error);
      setSnackbar({
        open: true,
        message: "Failed to revert credit.",
        severity: "error",
      });
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        Revert Credit - {currentUser?.username}
        <IconButton
          onClick={onClose}
          sx={{ position: "absolute", right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Box mt={2}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <FormControl fullWidth margin="normal">
                <InputLabel>Balance Type</InputLabel>
                <Select
                  value={type}
                  onChange={(e) => setType(e.target.value)}
                  label="Balance Type"
                >
                  <MenuItem value="whatsapp_balance">WhatsApp Balance</MenuItem>
                  <MenuItem value="whatsapp_button_balance">
                    WhatsApp Button Balance
                  </MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Amount to Revert"
                type="number"
                value={credit}
                onChange={(e) => setCredit(e.target.value)}
                margin="normal"
                inputProps={{
                  min: "0",
                  step: "1",
                }}
                helperText="Enter positive amount to deduct"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Reason for Revert"
                value={remark}
                onChange={(e) => setRemark(e.target.value)}
                margin="normal"
              />
            </Grid>
          </Grid>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" color="error" onClick={handleRevertCredit}>
          Revert Credit
        </Button>
      </DialogActions>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Dialog>
  );
};

const WhiteListDialogContent = ({ currentUser, onClose, onSave }) => {
  const [number, setNumber] = useState("");
  const [numbers, setNumbers] = useState([]);

  const handleAdd = () => {
    if (number.trim() !== "") {
      setNumbers([...numbers, number]);
      setNumber("");
    }
  };

  const handleDelete = (index) => {
    const updated = numbers.filter((_, i) => i !== index);
    setNumbers(updated);
  };

  const handleDownload = () => {
    const content = numbers.join("\n");
    const blob = new Blob([content], { type: "text/plain" });
    const link = document.createElement("a");
    link.download = "whitelist.txt";
    link.href = URL.createObjectURL(blob);
    link.click();
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Typography
        variant="subtitle1"
        sx={{ fontWeight: "bold", mb: 2, color: "#1a237e" }}
      >
        Whitelist Numbers for {currentUser?.username}
      </Typography>
      <Box sx={{ display: "flex", mb: 2 }}>
        <TextField
          fullWidth
          size="small"
          variant="outlined"
          placeholder="Enter Number Here"
          value={number}
          onChange={(e) => setNumber(e.target.value)}
        />
        <Button variant="contained" sx={{ ml: 1 }} onClick={handleAdd}>
          Add
        </Button>
      </Box>
      <List sx={{ maxHeight: 300, overflow: "auto" }}>
        {numbers.map((num, index) => (
          <ListItem key={index} divider>
            <ListItemText primary={`${index + 1}. ${num}`} />
            <ListItemSecondaryAction>
              <IconButton
                edge="end"
                onClick={() => handleDelete(index)}
                sx={{ backgroundColor: "red", color: "#fff" }}
              >
                <DeleteIcon />
              </IconButton>
            </ListItemSecondaryAction>
          </ListItem>
        ))}
      </List>
      <Box sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}>
        <Button variant="contained" onClick={handleDownload}>
          Download ↓
        </Button>
        <Button variant="contained" onClick={() => onSave(numbers)}>
          Save Whitelist
        </Button>
      </Box>
    </Box>
  );
};

const ChangePasswordDialog = ({ currentUser, onClose }) => {
  const [newPassword, setNewPassword] = useState("");
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });

  const handleUpdate = async () => {
    if (!newPassword) {
      setSnackbar({
        open: true,
        message: "Password is required.",
        severity: "warning",
      });
      return;
    }

    try {
      const response = await axios.put(
        "https://d3ioa5kdb9.execute-api.ap-south-1.amazonaws.com/Tis_whatsapp_be/password",
        {
          username: currentUser.username,
          password: newPassword,
        },
        { headers: { "Content-Type": "application/json" } }
      );

      if (response?.status === 200) {
        setSnackbar({
          open: true,
          message: "✅ Password updated successfully!",
          severity: "success",
        });
        setNewPassword("");
        setTimeout(onClose, 2000);
      } else {
        setSnackbar({
          open: true,
          message: response?.data?.message || "❌ Failed to update password.",
          severity: "error",
        });
      }
    } catch (error) {
      console.error("API error:", error);
      let message = "❌ Failed to update password.";
      if (error.response) {
        message =
          error.response.data?.message ||
          `Error ${error.response.status}: ${error.response.statusText}`;
      } else if (error.request) {
        message = "No response from server. Check your network.";
      }
      setSnackbar({ open: true, message, severity: "error" });
    }
  };

  return (
    <Box sx={{ width: "100%", p: 3 }}>
      <Typography
        variant="subtitle1"
        sx={{ fontWeight: "bold", mb: 2, color: "#1a237e" }}
      >
        Change Password for {currentUser?.username}
      </Typography>

      <Typography variant="body2" sx={{ mb: 0.5 }}>
        New password:
      </Typography>
      <TextField
        fullWidth
        placeholder="Enter new password"
        type="password"
        size="small"
        variant="outlined"
        sx={{ mb: 3 }}
        value={newPassword}
        onChange={(e) => setNewPassword(e.target.value)}
      />

      <Button
        variant="contained"
        onClick={handleUpdate}
        sx={{
          background: "linear-gradient(to right, #0052D4, #4364F7, #6FB1FC)",
          color: "#fff",
          textTransform: "none",
          fontWeight: "bold",
          borderRadius: 2,
          py: 1,
          fontSize: "1rem",
        }}
      >
        🚀 Update
      </Button>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
      >
        <Alert
          severity={snackbar.severity}
          onClose={() => setSnackbar({ ...snackbar, open: false })}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

const UserManagementUI = () => {
  const navigate = useNavigate();
  const [selectedUserId, setSelectedUserId] = useState("");
  const [users, setUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });
  const [anchorEl, setAnchorEl] = useState(null);
  const [currentUser, setCurrentUser] = useState(null);
  const open = Boolean(anchorEl);

  // ✅ ADDED: Sorting state
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "none",
  });

  // Pagination state
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(15);

  // Dialog states
  const [whitelistDialogOpen, setWhitelistDialogOpen] = useState(false);
  const [changePasswordDialogOpen, setChangePasswordDialogOpen] =
    useState(false);
  const [addCreditDialogOpen, setAddCreditDialogOpen] = useState(false);
  const [revertCreditDialogOpen, setRevertCreditDialogOpen] = useState(false);
  const [balanceDialogOpen, setBalanceDialogOpen] = useState(false);
  const [balanceType, setBalanceType] = useState("");
  const [balanceValue, setBalanceValue] = useState("");
  const [balanceUser, setBalanceUser] = useState(null);
  const [balanceLoading, setBalanceLoading] = useState(false);

  const [whatsappBalance, setWhatsappBalance] = useState(null);
  const [wbtnBalance, setWbtnBalance] = useState(null);
  const [loadingStates, setLoadingStates] = useState({}); // For individual user loading states

  // const AnimatedButton = styled(Button)(({ theme }) => ({
  //   transition: "all 0.3s ease",
  //   transform: "scale(1)",
  //   boxShadow: theme.shadows[4],
  //   borderRadius: "8px",
  //   padding: "10px 20px",
  //   fontWeight: 600,
  //   "&:hover": {
  //     transform: "scale(1.05)",
  //     boxShadow: theme.shadows[10],
  //   },
  // }));

  // ✅ ENHANCED: Complete sorting function with proper status handling
  const handleSort = (key) => {
    let direction = "asc";

    if (sortConfig.key === key) {
      if (sortConfig.direction === "asc") {
        direction = "desc";
      } else if (sortConfig.direction === "desc") {
        direction = "none";
      }
    }

    setSortConfig({ key, direction });

    if (direction === "none") {
      // Reset to original order
      const dataToSort = searchTerm.trim() ? [...searchResults] : [...users];
      if (searchTerm.trim()) {
        setSearchResults(dataToSort);
      } else {
        setUsers(dataToSort);
      }
      return;
    }

    const dataToSort = searchTerm.trim() ? [...searchResults] : [...users];

    const sortedData = [...dataToSort].sort((a, b) => {
      let aValue = a[key];
      let bValue = b[key];

      // Handle empty values
      if (!aValue && !bValue) return 0;
      if (!aValue) return 1;
      if (!bValue) return -1;

      // ✅ FIXED: Status sorting - convert boolean to text for proper comparison
      if (key === "active") {
        const statusA = aValue ? "Enabled" : "Disabled";
        const statusB = bValue ? "Enabled" : "Disabled";
        return direction === "asc"
          ? statusA.localeCompare(statusB)
          : statusB.localeCompare(statusA);
      }

      // String comparison for text fields
      const valA = String(aValue || "")
        .toLowerCase()
        .trim();
      const valB = String(bValue || "")
        .toLowerCase()
        .trim();

      return direction === "asc"
        ? valA.localeCompare(valB)
        : valB.localeCompare(valA);
    });

    if (searchTerm.trim()) {
      setSearchResults(sortedData);
    } else {
      setUsers(sortedData);
    }
    setPage(0); // Reset to first page when sorting
  };

  // ✅ ADDED: Get sort icon for a column
  const getSortIcon = (key) => {
    if (sortConfig.key !== key) {
      return <UnfoldMoreIcon fontSize="small" sx={{ opacity: 0.5 }} />;
    }

    switch (sortConfig.direction) {
      case "asc":
        return <ArrowUpwardIcon fontSize="small" color="primary" />;
      case "desc":
        return <ArrowDownwardIcon fontSize="small" color="primary" />;
      default:
        return <UnfoldMoreIcon fontSize="small" sx={{ opacity: 0.5 }} />;
    }
  };

  // Fetch all users
  const fetchUsers = async () => {
    try {
      const res = await axios.post(
        "https://d3ioa5kdb9.execute-api.ap-south-1.amazonaws.com/Tis_whatsapp_be/user_list",
        { username: "sagar124" },
        { headers: { "Content-Type": "application/json" } }
      );
      setUsers(res.data["body-json"]?.body || []);
    } catch (error) {
      console.error("Failed to fetch users:", error);
    }
  };

  // Search users API - FIXED VERSION
  const searchUsers = async (searchKey) => {
    if (!searchKey.trim()) {
      setSearchResults([]);
      setIsSearching(false);
      return;
    }

    setIsSearching(true);
    try {
      const response = await axios.get(
        `https://d3ioa5kdb9.execute-api.ap-south-1.amazonaws.com/Tis_whatsapp_be/search_user?key=${encodeURIComponent(
          searchKey
        )}`
      );

      console.log("Search API Response:", response.data);

      // FIXED: Extract data from the correct response structure
      let items = [];
      if (response.data && response.data.body) {
        items = response.data.body.message || [];
      }

      console.log("Extracted items:", items);
      setSearchResults(items);
    } catch (error) {
      console.error("Search API error:", error);
      setSearchResults([]);
      setSnackbar({
        open: true,
        message: "Search failed. Please try again.",
        severity: "error",
      });
    } finally {
      setIsSearching(false);
    }
  };

  // Debounced search
  useEffect(() => {
    const timer = setTimeout(() => {
      searchUsers(searchTerm);
    }, 500);

    return () => clearTimeout(timer);
  }, [searchTerm]);

  // ✅ KEPT: Working enable/disable user function from first code
  const handleToggleUserStatus = async (username, currentStatus) => {
    const newStatus = !currentStatus;

    // Set loading state for this specific user
    setLoadingStates((prev) => ({ ...prev, [username]: true }));

    try {
      const response = await axios.post(
        "https://d3ioa5kdb9.execute-api.ap-south-1.amazonaws.com/Tis_whatsapp_be/account",
        {
          username: username,
          active: newStatus,
        },
        {
          headers: { "Content-Type": "application/json" },
        }
      );

      if (response.status === 200) {
        // Update local state
        setUsers((prevUsers) =>
          prevUsers.map((user) =>
            user.username === username ? { ...user, active: newStatus } : user
          )
        );

        setSnackbar({
          open: true,
          message: `User ${newStatus ? "enabled" : "disabled"} successfully!`,
          severity: "success",
        });
      } else {
        setSnackbar({
          open: true,
          message: "Failed to update user status.",
          severity: "error",
        });
      }
    } catch (error) {
      console.error("Toggle user status failed:", error);
      setSnackbar({
        open: true,
        message: "Failed to update user status. Please try again.",
        severity: "error",
      });
    } finally {
      // Clear loading state for this user
      setLoadingStates((prev) => ({ ...prev, [username]: false }));
    }
  };

  // Handle view balance click
  const handleViewBalance = async (user, type) => {
    setBalanceLoading(true);
    setBalanceUser(user);
    setBalanceType(type);
    setBalanceDialogOpen(true);

    try {
      const response = await axios.post(
        "https://d3ioa5kdb9.execute-api.ap-south-1.amazonaws.com/Tis_whatsapp_be/balance_check",
        { username: user.username },
        { headers: { "Content-Type": "application/json" } }
      );

      console.log("Balance API Response:", response.data);

      // Extract balance data from response based on the provided structure
      const balanceData = response.data?.["body-json"]?.body?.Item || {};

      let balance = "0";
      if (type === "whatsapp") {
        balance = balanceData.whatsapp_balance || "0";
      } else if (type === "whatsapp_button") {
        balance = balanceData.whatsapp_button_balance || "0";
      }

      setBalanceValue(balance.toString());
    } catch (error) {
      console.error("Balance API error:", error);
      setBalanceValue("Error fetching balance");
      setSnackbar({
        open: true,
        message: "Failed to fetch balance",
        severity: "error",
      });
    } finally {
      setBalanceLoading(false);
    }
  };

  const handleClick = (event, user) => {
    setAnchorEl(event.currentTarget);
    setCurrentUser(user);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMenuItemClick = (option) => {
    handleClose();
    if (option.action === "whitelist") {
      setWhitelistDialogOpen(true);
    } else if (option.action === "changePassword") {
      setChangePasswordDialogOpen(true);
    } else if (option.action === "addCredit") {
      setAddCreditDialogOpen(true);
    } else if (option.action === "revertCredit") {
      setRevertCreditDialogOpen(true);
    }
  };

  const handleSaveWhitelist = async (numbers) => {
    if (!currentUser) return;

    try {
      const response = await axios.post("YOUR_WHITELIST_API_ENDPOINT", {
        username: currentUser.username,
        numbers: numbers,
      });
      console.log(response)

      setSnackbar({
        open: true,
        message: "Numbers whitelisted successfully!",
        severity: "success",
      });
      setWhitelistDialogOpen(false);
    } catch (error) {
      console.error("Whitelist failed:", error);
      setSnackbar({
        open: true,
        message: "Failed to whitelist numbers",
        severity: "error",
      });
    }
  };

  const handleCloseBalanceDialog = () => {
    setBalanceDialogOpen(false);
    setBalanceType("");
    setBalanceUser(null);
    setBalanceValue("");
    setBalanceLoading(false);
  };

  // Search handler
  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
    setPage(0);
  };

  // Pagination handlers
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    const fetchBalance = async () => {
      try {
        const storedUser = localStorage.getItem("user");
        const parsedUser = storedUser ? JSON.parse(storedUser) : null;
        const username = parsedUser?.username || "sagar124";

        const response = await axios.post(
          "https://d3ioa5kdb9.execute-api.ap-south-1.amazonaws.com/Tis_whatsapp_be/credit_user",
          {
            username: username,
          }
        );

        const body =
          response.data?.["body-json"]?.body || response.data?.body || {};
        const item = body?.Items?.[0] || {};

        setWhatsappBalance(item.whatsapp_balance || 0);
        setWbtnBalance(item.whatsapp_button_balance || 0);
      } catch (error) {
        console.error("Failed to fetch WhatsApp balance:", error);
      }
    };

    fetchBalance();
    fetchUsers();
  }, []);

  // Determine which users to display
  const displayUsers = searchTerm.trim() ? searchResults : users;

  // Filter users based on selected user ID
  const filteredUsers = selectedUserId
    ? displayUsers.filter((user) => user.username === selectedUserId)
    : displayUsers;

  // Apply pagination to filtered users
  const paginatedUsers = filteredUsers.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  return (
    <Box p={3} bgcolor="#f8f9fc" sx={{ mt: { xs: 3, sm: 6 } }}>
      {/* Top dashboard summary */}
      <Grid container spacing={2} mb={2}>
        <Grid item xs={12} sm={6} md={3}>
          <Box
            bgcolor="#e5e1f9"
            p={1}
            borderRadius={2}
            display="flex"
            alignItems="center"
            gap={2}
          >
            <ViewModuleIcon />
            <Box>
              <Typography fontWeight={300}>WB</Typography>
              <Typography variant="h6">
                {whatsappBalance !== null ? whatsappBalance : "Loading..."}
              </Typography>
            </Box>
          </Box>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Box
            bgcolor="#e5e1f9"
            p={1}
            borderRadius={2}
            display="flex"
            alignItems="center"
            gap={2}
          >
            <ShoppingCartIcon />
            <Box>
              <Typography fontWeight={300}>WBTN</Typography>
              <Typography variant="h6">
                {wbtnBalance !== null ? wbtnBalance : "Loading..."}
              </Typography>
            </Box>
          </Box>
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
          display="flex"
          justifyContent={{ xs: "center", md: "flex-end" }}
          alignItems="center"
          sx={{ paddingLeft: { xs: 0, sm: 40, md: 80 } }}
        >
          <Button
            variant="contained"
            color="primary"
            onClick={() => navigate("/users/adduser")}
          >
            Add User
          </Button>
        </Grid>
      </Grid>

      {/* Search and Filter Section */}
     <Grid container spacing={2} alignItems="center" mb={2}>
  <Grid item xs={12} md={6}>
    <TextField
      fullWidth
      size="small"
      variant="outlined"
      placeholder="Search users by name, user ID, incharge name, or email..."
      value={searchTerm}
      onChange={handleSearchChange}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon fontSize="small" sx={{ color: "#757575" }} /> {/* soft gray icon */}
          </InputAdornment>
        ),
        endAdornment: isSearching ? (
          <InputAdornment position="end">
            <CircularProgress size={16} sx={{ color: "#9e9e9e" }} />
          </InputAdornment>
        ) : null,
      }}
      sx={{
        "& .MuiOutlinedInput-root": {
          borderRadius: 2,
          backgroundColor: "#f9f9f9", 
          width:"440px",
          height: "36px",
          fontSize: "0.875rem",
          transition: "all 0.2s ease-in-out",
          "& input": {
            padding: "6px 10px",
            color: "#333", 
          },
          "& fieldset": {
            borderColor: "#e0e0e0",
          },
          "&:hover fieldset": {
            borderColor: "#bdbdbd", 
          },
          "&.Mui-focused fieldset": {
            borderColor: "#9e9e9e",
          },
        },
      }}
    />
  </Grid>


        <Grid item xs={12} md={6}>
          <Box display="flex" alignItems="center" gap={1}>
            {/* <Typography variant="subtitle1" fontWeight="bold" minWidth={80}>
              User ID:
            </Typography> */}
            <Typography >
              {/* <InputLabel id="user-id-select-label">Select User ID</InputLabel> */}
              <Typography
             
                value={selectedUserId}
                
                onChange={(e) => {
                  setSelectedUserId(e.target.value);
                  setPage(0);
                }}
              >
               
               
               
              </Typography>
            </Typography>
          </Box>
        </Grid>
      </Grid>

      {/* Results count */}
      {searchTerm && (
        <Typography variant="body2" color="textSecondary" mb={2}>
          Found {filteredUsers.length} user(s) matching "{searchTerm}"
          {isSearching && " (searching...)"}
        </Typography>
      )}

      {/* User Table with Pagination */}
      <Paper elevation={3} sx={{ p: 2, marginTop: 2 }}>
        <TableContainer component={Paper} sx={{ boxShadow: 2 }}>
          <Table size="small">
            <TableHead sx={{ background: "#e1f5fe" }}>
              <TableRow>
                {/* ✅ ENHANCED: Sortable NAME column */}
                <TableCell
                  onClick={() => handleSort("name")}
                  sx={{
                    fontWeight: "bold",
                    py: 0.5,
                    cursor: "pointer",
                    userSelect: "none",
                    "&:hover": { backgroundColor: "#d4f1f4" },
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                    NAME
                    {getSortIcon("name")}
                  </Box>
                </TableCell>

                {/* ✅ ENHANCED: Sortable USER ID column */}
                <TableCell
                  onClick={() => handleSort("username")}
                  sx={{
                    fontWeight: "bold",
                    py: 0.5,
                    cursor: "pointer",
                    userSelect: "none",
                    "&:hover": { backgroundColor: "#d4f1f4" },
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                    USER ID
                    {getSortIcon("username")}
                  </Box>
                </TableCell>

                {/* ✅ ENHANCED: Sortable INCHARGE NAME column */}
                <TableCell
                  onClick={() => handleSort("parent_username")}
                  sx={{
                    fontWeight: "bold",
                    py: 0.5,
                    cursor: "pointer",
                    userSelect: "none",
                    "&:hover": { backgroundColor: "#d4f1f4" },
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                    INCHARGE NAME
                    {getSortIcon("parent_username")}
                  </Box>
                </TableCell>

                {/* ✅ ENHANCED: Sortable EMAIL ADDRESS column */}
                <TableCell
                  onClick={() => handleSort("email")}
                  sx={{
                    fontWeight: "bold",
                    py: 0.5,
                    cursor: "pointer",
                    userSelect: "none",
                    "&:hover": { backgroundColor: "#d4f1f4" },
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                    EMAIL ADDRESS
                    {getSortIcon("email")}
                  </Box>
                </TableCell>

                <TableCell sx={{ fontWeight: "bold", py: 0.5 }}>
                  VIEW BALANCE
                </TableCell>

                {/* ✅ FIXED: Status sorting with proper boolean to text conversion */}
                <TableCell
                  onClick={() => handleSort("active")}
                  sx={{
                    fontWeight: "bold",
                    py: 0.5,
                    cursor: "pointer",
                    userSelect: "none",
                    "&:hover": { backgroundColor: "#d4f1f4" },
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                    STATUS
                    {getSortIcon("active")}
                  </Box>
                </TableCell>

                <TableCell sx={{ fontWeight: "bold", py: 0.5 }}>
                  UPDATE VALIDITY
                </TableCell>
                <TableCell sx={{ fontWeight: "bold", py: 0.5 }}>
                  FACILITY
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {paginatedUsers.length > 0 ? (
                paginatedUsers.map((user, i) => (
                  <TableRow key={i} hover sx={{ "& > *": { py: 0.5 } }}>
                    <TableCell sx={{ py: 0.5 }}>{user.name}</TableCell>
                    <TableCell sx={{ py: 0.5 }}>{user.username}</TableCell>
                    <TableCell sx={{ py: 0.5 }}>
                      {user.parent_username}
                    </TableCell>
                    <TableCell sx={{ py: 0.5 }}>{user.email}</TableCell>
                    <TableCell sx={{ py: 0.5 }}>
                      <Box display="flex" gap={0.5}>
                        <Tooltip title="Whatsapp Balance">
                          <IconButton
                            size="small"
                            onClick={() => handleViewBalance(user, "whatsapp")}
                            sx={{
                              color: "black",
                              bgcolor: "rgba(0,0,0,0.1)",
                              p: 0.5,
                            }}
                          >
                            <VisibilityIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Whatsapp Button Balance">
                          <IconButton
                            size="small"
                            onClick={() =>
                              handleViewBalance(user, "whatsapp_button")
                            }
                            sx={{
                              color: "red",
                              bgcolor: "rgba(255,0,0,0.15)",
                              p: 0.5,
                            }}
                          >
                            <VisibilityIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                      </Box>
                    </TableCell>
                    <TableCell sx={{ py: 0.5 }}>
                      <Box display="flex" alignItems="center" gap={0.5}>
                        {loadingStates[user.username] ? (
                          <CircularProgress size={20} />
                        ) : (
                          <Switch
                            size="small"
                            checked={user.active || false}
                            onChange={() =>
                              handleToggleUserStatus(
                                user.username,
                                user.active || false
                              )
                            }
                          />
                        )}
                        <Typography variant="body2" sx={{ fontSize: "0.8rem" }}>
                          {user.active ? "Enabled" : "Disabled"}
                        </Typography>
                      </Box>
                    </TableCell>
                    <TableCell sx={{ py: 0.5 }}>
                      <IconButton
                        size="small"
                        onClick={() => navigate("/users/validity")}
                        sx={{ color: "white", bgcolor: "black", p: 0.5 }}
                      >
                        <CalendarMonthIcon fontSize="small" />
                      </IconButton>
                    </TableCell>
                    <TableCell sx={{ py: 0.5 }}>
                      <IconButton
                        size="small"
                        aria-label="more"
                        id={`long-button-${i}`}
                        aria-controls={open ? `long-menu-${i}` : undefined}
                        aria-expanded={open ? "true" : undefined}
                        aria-haspopup="true"
                        onClick={(e) => handleClick(e, user)}
                        sx={{ p: 0.5 }}
                      >
                        <MoreVertIcon fontSize="small" />
                      </IconButton>
                      <Menu
                        id={`long-menu-${i}`}
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleClose}
                        slotProps={{
                          paper: {
                            style: {
                              maxHeight: ITEM_HEIGHT * 4.5,
                              width: "20ch",
                            },
                          },
                          list: {
                            "aria-labelledby": `long-button-${i}`,
                          },
                        }}
                      >
                        {options.map((option, index) => (
                          <MenuItem
                            key={index}
                            onClick={() => handleMenuItemClick(option)}
                          >
                            {option.label}
                          </MenuItem>
                        ))}
                      </Menu>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={8} align="center" sx={{ py: 3 }}>
                    <Typography variant="body1" color="textSecondary">
                      {isSearching
                        ? "Searching..."
                        : "No users found matching your search criteria."}
                    </Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Pagination Component */}
        <TablePagination
          rowsPerPageOptions={[]}
          component="div"
          count={filteredUsers.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          sx={{
            borderTop: "1px solid #e0e0e0",
            ".MuiTablePagination-toolbar": {
              minHeight: "52px",
            },
            ".MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows":
              {
                marginBottom: 0,
              },
          }}
          labelDisplayedRows={({ from, to, count }) =>
            `${from}-${to} of ${count !== -1 ? count : `more than ${to}`}`
          }
          labelRowsPerPage={null}
        />
      </Paper>

      {/* Add Credit Dialog */}
      <AddCreditDialog
        open={addCreditDialogOpen}
        onClose={() => setAddCreditDialogOpen(false)}
        currentUser={currentUser}
      />

      {/* Revert Credit Dialog */}
      <RevertCreditDialog
        open={revertCreditDialogOpen}
        onClose={() => setRevertCreditDialogOpen(false)}
        currentUser={currentUser}
      />

      {/* Whitelist Dialog */}
      <Dialog
        open={whitelistDialogOpen}
        onClose={() => setWhitelistDialogOpen(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          Whitelist Numbers
          <IconButton
            onClick={() => setWhitelistDialogOpen(false)}
            sx={{ position: "absolute", right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <WhiteListDialogContent
            currentUser={currentUser}
            onClose={() => setWhitelistDialogOpen(false)}
            onSave={handleSaveWhitelist}
          />
        </DialogContent>
      </Dialog>

      {/* Change Password Dialog */}
      <Dialog
        open={changePasswordDialogOpen}
        onClose={() => setChangePasswordDialogOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          Change Password
          <IconButton
            onClick={() => setChangePasswordDialogOpen(false)}
            sx={{ position: "absolute", right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <ChangePasswordDialog
            currentUser={currentUser}
            onClose={() => setChangePasswordDialogOpen(false)}
          />
        </DialogContent>
      </Dialog>

      {/* Balance Dialog */}
      <Dialog
        open={balanceDialogOpen}
        onClose={handleCloseBalanceDialog}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          {balanceType === "whatsapp"
            ? "WhatsApp Balance"
            : balanceType === "whatsapp_button"
            ? "WhatsApp Button Balance"
            : "Balance"}
        </DialogTitle>
        <DialogContent>
          <Typography variant="subtitle1" gutterBottom>
            User: {balanceUser?.username}
          </Typography>
          <Box sx={{ mt: 2 }}>
            {balanceLoading ? (
              <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                <CircularProgress size={20} />
                <Typography>Loading balance...</Typography>
              </Box>
            ) : (
              <Box>
                <Typography
                  variant="h5"
                  sx={{ fontWeight: "bold", color: "#1976d2" }}
                >
                  {balanceValue}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ mt: 1, color: "text.secondary" }}
                >
                  {balanceType === "whatsapp"
                    ? "WhatsApp message balance"
                    : "WhatsApp button message balance"}
                </Typography>
              </Box>
            )}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseBalanceDialog}>Close</Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
      >
        <Alert
          severity={snackbar.severity}
          onClose={() => setSnackbar({ ...snackbar, open: false })}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default UserManagementUI;